module.exports = __webpack_public_path__ + "static/FeatureHeaderBackground.0cd1b927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pngs/FeatureHeaderBackground.png
// module id = ./src/assets/pngs/FeatureHeaderBackground.png
// module chunks = 72138227098318